import moment from "moment";
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FormFeedback } from "reactstrap";

interface TimepickerProps {
  name: string;
  selectedTime: string | null;
  onChange: (name: string, value: Date | null) => void;
  placeholder?: string;
  dateFormat?: string;
  timeFormat?: string;
  isDisabled?: boolean;
  error?: string;
  timeCaption?: string;
  minHour?: number;
  maxHour?: number;
}

const TimePicker: React.FC<TimepickerProps> = ({
  name,
  selectedTime,
  onChange,
  placeholder = "Select",
  dateFormat = "HH:mm",
  timeFormat = "HH:mm",
  isDisabled = false,
  error = "",
  timeCaption = "Time",
  minHour = 0,
  maxHour = 23,
}) => {
  const value = selectedTime ? moment(selectedTime, "HH:mm").toDate() : null;

  const minTime = moment().hour(minHour).minute(0).second(0).toDate();
  const maxTime = moment().hour(maxHour).minute(0).second(0).toDate();

  return (
    <div style={{ width: "100%" }}>
      <DatePicker
        name={name}
        selected={value}
        onChange={(value: Date | null) => {
          if (!isDisabled) {
            onChange(name, value);
          }
        }}
        dateFormat={dateFormat}
        timeFormat={timeFormat}
        className={`form-control cursor-pointer ${error ? "is-invalid" : ""}`}
        wrapperClassName="w-100"
        placeholderText={placeholder}
        timeCaption={timeCaption}
        disabled={isDisabled}
        timeIntervals={60}
        showTimeSelect
        showTimeSelectOnly
        minTime={minTime}
        maxTime={maxTime}
      />
      {error && (
        <FormFeedback type="invalid" className="d-block">
          {error}
        </FormFeedback>
      )}
    </div>
  );
};

export default TimePicker;
